<div [formGroup]="formGroup" style="display: flex; gap: 8px; align-items: center">
  <mc-select ngDefaultControl [formControlName]="typeControlName" [label]="label" fit="medium" width="100" placeholder="Select Type">
    @for (opt of options; track opt.value) {
      <mc-option [value]="opt.value">{{ opt.label }}</mc-option>
    }
  </mc-select>

  @if (isBetween) {
    <mc-input-date
      label="From"
      startofweek="1"
      format="DD-MM-YYYY"
      nextlabel="Next month"
      previouslabel="Previous month"
      placeholder="DD-MM-YYYY"
      width="auto"
      ngDefaultControl
      [formControlName]="fromControlName">
    </mc-input-date>
    <mc-input-date
      label="To"
      startofweek="1"
      format="DD-MM-YYYY"
      nextlabel="Next month"
      previouslabel="Previous month"
      placeholder="DD-MM-YYYY"
      width="auto"
      ngDefaultControl
      [formControlName]="toControlName">
    </mc-input-date>
  } @else {
    <mc-input-date
      label="Select"
      startofweek="1"
      format="DD-MM-YYYY"
      nextlabel="Next month"
      previouslabel="Previous month"
      placeholder="DD-MM-YYYY"
      width="auto"
      ngDefaultControl
      [formControlName]="dateControlName">
    </mc-input-date>
  }
</div>
